<template>
  <div>
    <div v-if="listType == 'liste'">
      <el-col
        v-for="blog in shortingBlog()"
        :key="blog.id"
        :class="isMobileLayout ? 'padListElement--mobile' : 'padListElement'"
      >
        <BlogCardListView :blog="blog" :is-filter-visible="isFilterVisible" />
      </el-col>
    </div>
    <el-row v-else class="blog-view">
      <el-col
        v-for="blog in blogs"
        :key="blog.id"
        :span="span"
        :class="isMobileLayout ? 'padListElement--mobile' : 'padListElement'"
      >
        <!-- <BlogVideo v-if="blog.type.code == 'VIDEO'" :title="blog.user.firstName+' '+blog.user.lastName"
            :description="blog.title"
            :isBlogPage="true"
            :blog="blog"
            :link="blog.videoLink"
            :thumbnail-image="blog.mainImage.thumbnailLink"></BlogVideo> -->
        <BlogCard :blog="blog" :is-filter-visible="isFilterVisible" />
        <!-- <BlogCard :blog="blog" :is-filter-visible="isFilterVisible" :link="blog.type.code == 'VIDEO' ?  blog.videoLink : ''" /> -->
      </el-col>
    </el-row>
  </div>
</template>

<script>
import layoutUtils from "@/utils/layout-utils";

import BlogCard from "./blog-card.vue";
import BlogCardListView from "./blog-card-list-view.vue";
// import BlogVideo from './blog-video.vue';
import "@fancyapps/ui/dist/fancybox.css";
import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox";

export default {
  components: {
    BlogCard,
    BlogCardListView,
    // BlogVideo,
  },
  props: {
    blogs: {
      type: Array,
      default: () => [],
    },
    span: {
      type: Number,
      default: 0,
    },
    isFilterVisible: {
      type: Boolean,
      default: true,
    },
    listType: {
      type: String,
      default: "tuiles",
    },
  },
  data() {
    return {};
  },
  computed: {
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
  },
  methods:{
    shortingBlog(){
      var blog = Object.assign([], this.blogs);
      blog.sort(function (a, b) {
        return a.publishedDate === b.publishedDate ? 0 : a.publishedDate < b.publishedDate ? 1 : -1;
      });
      return blog;
    },
    fancyBox() {
      Fancybox.show({}, {});
    },
  }
};
</script>

<style>
.padListElement--mobile {
  padding: 4px 4px 0 4px;
  margin-right: 0;
}
.padListElement {
  padding: 4px 4px 0 16px;
  margin-right: 0;
}
</style>
